import { render, staticRenderFns } from "./ConsultaWf1Component.vue?vue&type=template&id=1341e4e9&scoped=true"
import script from "./ConsultaWf1Component.vue?vue&type=script&lang=js"
export * from "./ConsultaWf1Component.vue?vue&type=script&lang=js"
import style0 from "./ConsultaWf1Component.vue?vue&type=style&index=0&id=1341e4e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1341e4e9",
  null
  
)

export default component.exports